// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-211aee7d] mark{display:block;background-color:#162c35;color:#e1e2e4;padding:.5rem 1rem;border-radius:.5rem}[data-v-211aee7d] p{margin-bottom:1.5rem}[data-v-211aee7d] h2{font-size:2rem;line-height:2.75rem;margin-bottom:3rem}[data-v-211aee7d] h2:not(:first-child){margin-top:4rem}[data-v-211aee7d] h3{font-size:1.25rem;line-height:1.75rem;margin-bottom:1rem}[data-v-211aee7d] h3:not(:first-child){margin-top:3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
